import './global.css';

let shouldUpdateScroll = true;

export const onInitialClientRender = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  // Listen to popstate to detect back/forward navigation
  window.addEventListener('popstate', () => {
    shouldUpdateScroll = false;
  });
};

export const onRouteUpdate = ({ location, prevLocation }) => {
  // Handle anchor navigation
  if (location.hash) {
    const el = document.querySelector(location.hash);
    if (el) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: 'smooth' });
      }, 0);
      return;
    }
  }

  // Scroll to top on route change, except on back/forward
  if (shouldUpdateScroll && prevLocation && location.pathname !== prevLocation.pathname) {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }

  // Reset the flag for next navigation
  shouldUpdateScroll = true;
};
